import { apiClient } from './api';

function unwrapData<T>(res: { success: boolean; data?: T; message?: string; error?: string }, fallbackMsg: string): T {
  if (!res.success || res.data === undefined) {
    throw new Error(res.message || res.error || fallbackMsg);
  }
  return res.data;
}

export type ShortLinkRow = {
  id: string;
  code: string;
  targetUrl: string;
  shortPath: string;
  clickCount: number;
  createdAt: string;
  updatedAt: string;
};

type PageResult<T> = {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

function mapRow(raw: Record<string, unknown>): ShortLinkRow {
  return {
    id: String(raw.id ?? ''),
    code: String(raw.code ?? ''),
    targetUrl: String(raw.targetUrl ?? raw.target_url ?? ''),
    shortPath: String(raw.shortPath ?? `/l/${raw.code ?? ''}`),
    clickCount: Number(raw.clickCount ?? raw.click_count ?? 0) || 0,
    createdAt: String(raw.createdAt ?? ''),
    updatedAt: String(raw.updatedAt ?? ''),
  };
}

export const shortLinkService = {
  async list(params: { page?: number; limit?: number } = {}): Promise<PageResult<ShortLinkRow>> {
    const res = await apiClient.get<PageResult<Record<string, unknown>>>('/admin/short-links', { params });
    const page = unwrapData(res, 'خطا در دریافت لینک‌های کوتاه');
    return {
      ...page,
      data: (page.data ?? []).map(mapRow),
    };
  },
  async create(data: { code?: string; targetUrl: string }): Promise<ShortLinkRow> {
    const res = await apiClient.post<Record<string, unknown>>('/admin/short-links', data);
    return mapRow(unwrapData(res, 'ایجاد لینک کوتاه ناموفق بود'));
  },
  async update(id: string, data: { code?: string; targetUrl: string }): Promise<ShortLinkRow> {
    const res = await apiClient.put<Record<string, unknown>>(`/admin/short-links/${id}`, data);
    return mapRow(unwrapData(res, 'ویرایش لینک کوتاه ناموفق بود'));
  },
  async remove(id: string): Promise<void> {
    const res = await apiClient.delete(`/admin/short-links/${id}`);
    if (!res.success) throw new Error(res.message || 'حذف لینک کوتاه ناموفق بود');
  },
};
